/**
 * @generated SignedSource<<a04ff5527aef26dfdbd0f2d55870257c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "OutboundHookPayload",
    "kind": "LinkedField",
    "name": "deleteOutboundHook",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Error",
        "kind": "LinkedField",
        "name": "error",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "OutboundHook",
        "kind": "LinkedField",
        "name": "hook",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "_id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SettingsModalQuery_deleteOutboundHookMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SettingsModalQuery_deleteOutboundHookMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1eeaca17f9a0032469677ec5a206ada5",
    "id": null,
    "metadata": {},
    "name": "SettingsModalQuery_deleteOutboundHookMutation",
    "operationKind": "mutation",
    "text": "mutation SettingsModalQuery_deleteOutboundHookMutation(\n  $input: DeleteOutboundHookInput!\n) {\n  deleteOutboundHook(input: $input) {\n    clientMutationId\n    error {\n      code\n      subType\n      message\n    }\n    hook {\n      id\n      _id\n    }\n  }\n}\n"
  }
};
})();

node.hash = "b46d0cc957fdfd1d4724e6c74d48f519";

module.exports = node;
